export const codeCroups = {
  "23b50564-39ed-11ef-8bc9-0242ac110004": "Дор. маш. (СО)",
  "23b3ad9a-39ed-11ef-8bc9-0242ac110004": "ПСР",
  "23b5f60e-39ed-11ef-8bc9-0242ac110004": "Погр. снг. (ГР)",
  "23b6d1aa-39ed-11ef-8bc9-0242ac110004": "Самосв. трак. (ГР)",
};

export const codeCroupsFulName = {
  "23b50564-39ed-11ef-8bc9-0242ac110004": "Дорожные машины (Снегоочистители)",
  "23b3ad9a-39ed-11ef-8bc9-0242ac110004": "Пескосолераспределители",
  "23b5f60e-39ed-11ef-8bc9-0242ac110004": "Погрузчики снега (Грейдеры)",
  "23b6d1aa-39ed-11ef-8bc9-0242ac110004": "Самосвалы, трактора на вывоз снега (Грейдеры)",
};
